// @flow
import Schedule from 'clark-schedule';

import styled from 'styled-components';
import { GREY_10, GREY_25 } from 'styles/colors';
import { BORDER_WIDTH_2 } from 'styles/borders';
import { SPACING_EXTRA_LARGE } from 'styles/spacing';
import { EASE_IN_OUT_25 } from 'styles/transitions';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const FullWidthBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 0;
  background: white;
  height: ${SPACING_EXTRA_LARGE};
  border-top: ${BORDER_WIDTH_2} solid ${GREY_10};
  border-bottom: ${BORDER_WIDTH_2} solid ${GREY_10};
`;

export const StyledSchedule = styled<any>(Schedule)`
  .rbc-time-content {
    background: white;
    &::-webkit-scrollbar {
      height: 12px;
      width: 12px;
      background: white;
    }

    &::-webkit-scrollbar-thumb {
      background: ${GREY_10};
      -webkit-border-radius: 1ex;
      ${EASE_IN_OUT_25};

      &:hover {
        background: ${GREY_25};
      }
    }

    &::-webkit-scrollbar-corner {
      background: #000;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/sessions/list/scheduled/styles.js